import type { ChangelogEntry } from "../types";

/**
 * VIB-2794. Dokumenteditoren fikk ikke fokus ved åpning, så markøren manglet.
 * Regresjon fra Lexical-byttet (VIB-2783).
 */
export const MARKOR_2026_10: ChangelogEntry = {
  id: "2026-10-06-markor",
  date: "2026-10-06",
  title: "Markøren står klar når du åpner et dokument",
  summary:
    "Du slipper å klikke i tekstfeltet før du kan begynne å skrive.",
  sections: [
    {
      heading: "Dokumentarkiv",
      items: [
        {
          title: "Du kan skrive med en gang",
          kind: "rettet",
          body: "Åpnet du et dokument for redigering, sto det ingen markør i teksten, og du måtte klikke i feltet før du kunne skrive. Nå står markøren klar med en gang, sist i teksten, så du kan skrive videre der du slapp.",
        },
      ],
    },
  ],
};
